import index from "./localMailHome.vue";
export default index;
